import { render, staticRenderFns } from "./OpenCloseIcon.vue?vue&type=template&id=12aab316"
import script from "./OpenCloseIcon.vue?vue&type=script&lang=ts"
export * from "./OpenCloseIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports